import React, { useState, useEffect } from 'react';
import SalaryMap from './SalaryMapFixed';
import SalaryCalculatorPanel from './SalaryCalculatorPanel';
import CompanyDetailsPanel from './CompanyDetailsPanel';
import SalarySearchSidebar from './SalarySearchSidebar';
import { CountryData, countryData } from '../data/countryData';
import { Company } from '../types/CompanyTypes';
import 'mapbox-gl/dist/mapbox-gl.css';
import './Salaries.css';
import './UnifiedSidebar.css';

interface SalariesProps {
  darkMode: boolean;
  onLoginRequired?: (action: 'apply' | 'save' | 'share' | 'referral' | string) => void;
  onNavigateToCompanies?: (filters: { company?: string; location?: string }) => void;
  onNavigateToJobs?: (filters: { position?: string; location?: string; salaryMin?: number }) => void;
}

const Salaries: React.FC<SalariesProps> = ({ darkMode, onLoginRequired, onNavigateToCompanies, onNavigateToJobs }) => {
  const [selectedCountry, setSelectedCountry] = useState<CountryData | null>(null);
  const [selectedCompany, setSelectedCompany] = useState<Company | null>(null);
  const [heatmapMode, setHeatmapMode] = useState<boolean>(true);
  const [dataType, setDataType] = useState<'jobs' | 'salaries' | 'companies'>('salaries');
  // Removed boundary visualization toggle - using enhanced heatmap only

  useEffect(() => {
    console.log('Salaries component mounted');
    return () => {
      console.log('Salaries component unmounted');
    };
  }, []);

  const handleCountrySelect = (country: CountryData) => {
    console.log('Country selected:', country);
    setSelectedCountry(country);
  };

  const handleClosePanel = () => {
    setSelectedCountry(null);
  };

  const handleCompanySelect = (company: Company) => {
    console.log('Salaries.handleCompanySelect called with:', company.name);
    console.log('Setting selectedCompany to:', company);
    setSelectedCompany(company);
    setSelectedCountry(null); // Close country panel if open
  };

  const handleCloseCompanyPanel = () => {
    setSelectedCompany(null);
  };

  return (
    <div className="salaries-page">
      <SalarySearchSidebar
        countries={countryData}
        onCountrySelect={handleCountrySelect}
        darkMode={darkMode}
      />
      
      <div className="salaries-map-container">
        {/* Using enhanced heatmap with built-in controls */}
        <SalaryMap 
          onCountrySelect={handleCountrySelect}
          onCompanySelect={handleCompanySelect}
          darkMode={darkMode}
          heatmapMode={heatmapMode}
          dataType={dataType}
          onDataTypeChange={setDataType}
          onLoginRequired={onLoginRequired}
        />
      </div>
      
      <SalaryCalculatorPanel
        country={selectedCountry}
        onClose={handleClosePanel}
        darkMode={darkMode}
        onNavigateToCompanies={onNavigateToCompanies}
        onNavigateToJobs={onNavigateToJobs}
      />
      
      <CompanyDetailsPanel
        company={selectedCompany}
        onClose={handleCloseCompanyPanel}
        darkMode={darkMode}
        onLoginRequired={onLoginRequired}
      />
    </div>
  );
};

export default Salaries;